module.exports = __webpack_public_path__ + "img/italic-02.f34874ef.svg";